import { useState } from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { ADMISSION_STATUS, ADMISSION_STATUS_REASON, STATUS_CONFIG, STATUS_REASON_LABELS } from "../../utils";

const ARCHIVE_REASONS = [ADMISSION_STATUS_REASON.REJECTED, ADMISSION_STATUS_REASON.ABANDONED, ADMISSION_STATUS_REASON.MERGED];

const ForceStatusModal = ({ fromStatus, toStatus, loading = false, onClose, onConfirm }) => {
  const [statusReason, setStatusReason] = useState(ADMISSION_STATUS_REASON.REJECTED);
  const fromLabel = STATUS_CONFIG[fromStatus]?.label || fromStatus;
  const toLabel = STATUS_CONFIG[toStatus]?.label || toStatus;
  const needsStatusReason = toStatus === ADMISSION_STATUS.ARCHIVED;
  const leavesRecorded = fromStatus === ADMISSION_STATUS.RECORDED && toStatus === ADMISSION_STATUS.TO_VALIDATE;
  const canConfirm = needsStatusReason !== true || !!statusReason;

  let consequenceMessage = "";
  if (toStatus === ADMISSION_STATUS.TO_VALIDATE) {
    if (fromStatus === ADMISSION_STATUS.RECORDED) {
      consequenceMessage = "Le dossier reviendra en revue. Une copie peut déjà exister dans le SIL — vous devez la traiter manuellement côté laboratoire.";
    } else if (fromStatus === ADMISSION_STATUS.ARCHIVED) {
      consequenceMessage = "Le dossier sera restauré et reviendra dans la file à valider.";
    } else if (fromStatus === ADMISSION_STATUS.ERROR || fromStatus === ADMISSION_STATUS.FINALIZING || fromStatus === ADMISSION_STATUS.QUEUED) {
      consequenceMessage = "Le dossier reviendra en revue. Vous pourrez le corriger puis le re-valider pour l'envoyer au SIL.";
    } else {
      consequenceMessage = "Le dossier passera au statut À valider.";
    }
  } else if (toStatus === ADMISSION_STATUS.RECORDED) {
    consequenceMessage =
      "Le dossier sera marqué comme enregistré et quittera la file de traitement. Utilisez cette action si l'enregistrement a déjà été fait manuellement dans le SIL.";
  } else if (toStatus === ADMISSION_STATUS.ARCHIVED) {
    consequenceMessage = "Le dossier sera archivé et quittera la file de traitement.";
  }

  const onSubmit = async () => {
    if (canConfirm !== true || loading === true) return;
    await onConfirm({
      status: toStatus,
      statusReason: needsStatusReason === true ? statusReason : undefined,
    });
  };

  return (
    <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black/20">
      <div className="mx-4 w-full min-w-[500px] max-w-lg rounded-lg bg-white px-6 py-4">
        <h2 className="mb-4 text-lg font-medium text-gray-900">Forcer le statut</h2>

        <p className="mb-3 text-sm text-gray-600">
          <span className="font-medium text-gray-900">{fromLabel}</span>
          <span className="mx-2 text-gray-400">→</span>
          <span className="font-medium text-gray-900">{toLabel}</span>
        </p>

        {consequenceMessage && <p className="mb-4 text-sm text-gray-600">{consequenceMessage}</p>}

        {leavesRecorded === true && (
          <div className="mb-4 flex items-start gap-2 rounded-lg border border-orange-200 bg-orange-50 px-3 py-2 text-sm text-orange-800">
            <HiOutlineExclamationCircle className="mt-0.5 h-4 w-4 shrink-0" />
            <span>Attention : une copie peut déjà exister dans le SIL. Sa suppression ou correction reste à la charge du laboratoire.</span>
          </div>
        )}

        {needsStatusReason === true && (
          <div className="mb-4">
            <label htmlFor="forceStatusReason" className="mb-2 block text-sm font-medium text-gray-700">
              Motif d&apos;archivage
            </label>
            <select
              id="forceStatusReason"
              className="w-full rounded-md border border-gray-300 p-1.5 text-sm outline-none transition-all focus:border-primary-500 focus:ring-2 focus:ring-primary-500"
              value={statusReason}
              onChange={(e) => setStatusReason(e.target.value)}
            >
              {ARCHIVE_REASONS.map((reason) => (
                <option key={reason} value={reason}>
                  {STATUS_REASON_LABELS[reason] || reason}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            className="rounded-lg border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 disabled:opacity-50"
            onClick={onClose}
            disabled={loading === true}
          >
            Annuler
          </button>
          <button
            type="button"
            className="rounded-lg bg-primary-500 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-primary-700 disabled:opacity-50"
            onClick={onSubmit}
            disabled={canConfirm !== true || loading === true}
          >
            {loading === true ? "Chargement..." : "Confirmer"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForceStatusModal;
